import React from 'react';
import { ThomasCampaign } from 'models/interfaces';
import { CONSTANTS } from '@tpco/tpco-saturn-types';
import { printDate } from 'util/dateUtils';
import {
  DeleteIcon,
  GrayDeleteIcon,
  DuplicateIcon,
  EditIcon,
  OptimizationIcon,
  GrayDuplicateIcon,
  GrayEditIcon,
  GrayOptimizationIcon
} from '../Icons/EditIcons';
import { TableRow, TableHeading } from 'models/interfaces/Table';
import { buildURL } from 'util/nameHelper';
const campaignHeadings: TableHeading[] = [
  {
    key: 'name',
    value: 'Name'
  },
  {
    key: 'opportunityId',
    value: 'Opportunity ID',
    style: 'align-center'
  },
  {
    key: 'start_date',
    value: 'Campaign Start',
    style: 'align-right'
  },
  {
    key: 'end_date',
    value: 'Campaign End',
    style: 'align-right'
  },
  {
    key: 'product',
    value: 'Product'
  },
  {
    key: 'status',
    value: 'Status',
    style: 'align-center'
  },
  {
    key: 'quantity',
    value: 'Quantity',
    style: 'align-right'
  },
  {
    key: 'created_date',
    value: 'Date Created',
    style: 'align-right'
  },
  {
    key: 'action',
    value: 'Actions',
    style: 'align-center'
  }
];

const p3CampaignHeadings: TableHeading[] = [
  {
    key: 'name',
    value: 'Name'
  },
  {
    key: 'opportunityId',
    value: 'Opportunity ID',
    style: 'align-center'
  },
  {
    key: 'start_date',
    value: 'Campaign Start',
    style: 'align-right'
  },

  {
    key: 'end_date',
    value: 'Campaign End',
    style: 'align-right'
  },
  {
    key: 'status',
    value: 'Status',
    style: 'align-center'
  },
  {
    key: 'quantity',
    value: 'Points',
    style: 'align-right'
  },
  {
    key: 'created_date',
    value: 'Date Created',
    style: 'align-right'
  },
  {
    key: 'action',
    value: 'Actions',
    style: 'align-center'
  }
];
const createCampaignRow = (
  campaign: any,
  tgramsId,
  campaignIsEditable,
  campaignIsOptimizable,
  campaignIsDeletable,
  campaignIsDuplicable,
  onDuplicateCampaign,
  onDeleteCampaign,
  onOptimizeCampaign,
  isP3,
  productId,
  opportunity_id,
  quantity
) => {
  // add all of the props on ThomasCampaign to tr data
  const campaignRow: TableRow = campaign;
  campaignRow.opportunityId = opportunity_id;
  campaignRow.quantity = quantity;
  // add edit, duplicate, and delete functionality
  campaignRow.action = (
    <div className="creative-list__action-container">
      {campaignIsEditable ? (
        <button
          className="btn creative-list__action btn-fix"
          style={{ padding: '0', margin: '0' }}
          onClick={async () =>
            (location.href = buildURL(
              `/advertisers/${tgramsId}/campaigns/${campaign.campaign_id}/edit`
            ))
          }
        >
          <EditIcon />
        </button>
      ) : (
        <button className="btn creative-list__action btn-fix" style={{ padding: '0', margin: '0' }}>
          <GrayEditIcon />
        </button>
      )}

      {campaign.product_id !== CONSTANTS.CAMPAIGN_PRODUCT_TYPE.POINTS && campaignIsDuplicable ? (
        <button
          className="btn creative-list__action btn-fix"
          style={{ padding: '0', margin: '0' }}
          onClick={async () => {
            await onDuplicateCampaign(campaign.campaign_id);
          }}
        >
          <DuplicateIcon />
        </button>
      ) : (
        <button
          className="btn creative-list__action btn-fix"
          style={{ padding: '0', margin: '0' }}
          onClick={async () => alert('Cannot duplicate a p3 campaign!')}
        >
          <GrayDuplicateIcon />
        </button>
      )}

      {campaignIsDeletable ? (
        <button
          className="btn creative-list__action btn-fix"
          style={{ padding: '0', margin: '0' }}
          onClick={async () => await onDeleteCampaign(campaign.campaign_id)}
        >
          <DeleteIcon />
        </button>
      ) : (
        <button
          className="btn creative-list__action btn-fix disabled"
          style={{ padding: '0', margin: '0' }}
          onClick={async () => alert('This campaign cannot be deleted!')}
        >
          <GrayDeleteIcon />
        </button>
      )}

      {campaignIsOptimizable ? (
        <button
          className="btn creative-list__action btn-fix"
          style={{ padding: '0', margin: '0' }}
          onClick={() => onOptimizeCampaign(campaign)}
        >
          <OptimizationIcon />
        </button>
      ) : (
        <button
          className="btn creative-list__action btn-fix disabled"
          style={{ padding: '0', margin: '0' }}
          onClick={async () => alert('This campaign cannot be optimized!')}
        >
          <GrayOptimizationIcon />
        </button>
      )}
    </div>
  );

  // override campaign values
  campaignRow.created_date = campaign.created_date ? printDate(campaign.created_date) : '';
  campaignRow.start_date = campaign.start_date ? printDate(campaign.start_date) : '';
  campaignRow.end_date = campaign.end_date ? printDate(campaign.end_date) : '';
  campaignRow.status = CONSTANTS.CAMPAIGN_STATUS_MAP[campaign.status_id] || null;
  if (isP3 && productId === CONSTANTS.CAMPAIGN_PRODUCT_TYPE.POINTS) {
    campaignRow.points = campaign.entitled_rank_points || '';
  } else {
    campaignRow.product = CONSTANTS.PRODUCT_TYPE_MAP[campaign.product_id] || '';
  }
  campaignRow.prospect = '';

  return campaignRow;
};

const createCampaignRows = (
  campaigns: ThomasCampaign[] = [],
  tgramsId,
  campaignIsEditable,
  campaignIsOptimizable,
  campaignIsDeletable,
  campaignIsDuplicable,
  onDuplicateCampaign,
  onDeleteCampaign,
  onOptimizeCampaign,
  isP3,
  productId,
  opportunityId,
  quantity
) => {
  return campaigns.map((x: ThomasCampaign) =>
    createCampaignRow(
      x,
      tgramsId,
      campaignIsEditable,
      campaignIsOptimizable,
      campaignIsDeletable,
      campaignIsDuplicable,
      onDuplicateCampaign,
      onDeleteCampaign,
      onOptimizeCampaign,
      isP3,
      productId,
      opportunityId,
      quantity
    )
  );
};

export { campaignHeadings, p3CampaignHeadings, createCampaignRow, createCampaignRows };
